import React, { Component } from "react";
import { GiBeveledStar } from 'react-icons/gi';
import './pagestyle.css';


export default class Contact extends Component {

    render() {
        return (
            <div className="Body m-5 my-center">
                {/* <h1>
                    Contact
                </h1> */}
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <p className="description">< GiBeveledStar /></p>
                <br></br>
                <p className="description">
                    To inquire about custom pieces or prints, or display art at your business, email anne.jamboretz@gmail.com.
                </p>
                <br></br>
                <p className="description">< GiBeveledStar /></p>

            </div>
        );
    }
}